module.exports = "/wwwroot/img/waste_category_list_page.png?ver=3953eaad";